<div class="returns-container">
  <!-- Header -->
  <div class="header">
    <div class="title-row">
      <h2>My Returns</h2>
      <div class="total-returns">Total Returns: {{ filteredList.length }}</div>
    </div>
    <p>Track your returns easily</p>

    <div class="custom-input-wrapper" (click)="$event.stopPropagation()">
      <i class="SearchBarIcon">search</i>
      <input
        type="text"
        class="custom-search-input"
        [(ngModel)]="searchText"

        (ngModelChange)="onInputChange()"
        (click)="isInputVisible = true"
      />
      <div class="scroll-text-container" *ngIf="!searchText && !isInputVisible" >
        <div id="animation-1" class="SearchBarAnimationText">Search by "Return ID"</div>
        <div id="animation-2" class="SearchBarAnimationText">Search by "Item Name"</div>
        <div id="animation-3" class="SearchBarAnimationText">Search by "Reason"</div>
        <div id="animation-4" class="SearchBarAnimationText">Search by "Invoice No"</div>
        <div id="animation-5" class="SearchBarAnimationText">Search by "Part No"</div>
        <div id="animation-6" class="SearchBarAnimationText">Search by "Order ID"</div>
      </div>
      <span *ngIf="searchText || isInputVisible" class="custom-close-button" (click)="clearSearch()">✖</span>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <button [class.active]="selectedTab === 'All'" (click)="setTab('All')">All</button>
    <button [class.active]="selectedTab === 'Created'" (click)="setTab('Created')">Created</button>
    <button [class.active]="selectedTab === 'Received'" (click)="setTab('Received')">Received</button>
    <button [class.active]="selectedTab === 'Refunded'" (click)="setTab('Refunded')">Refunded</button>
    <button [class.active]="selectedTab === 'Declined'" (click)="setTab('Declined')">Declined</button>
  </div>


  <!-- Return Cards -->
   <div *ngFor="let item of (searchText ? filteredData : filteredList)">
    <div class="return-card"  *ngIf="item.returnId"  (click)="openPopup(item)">
      <div class="card-header">
        <div class="ret-id-and-status-main">
          <span class="ret-id">{{ item.returnId  || 'null' }}</span>
          <span class="status-badge" [ngClass]="getStatusClass1(item.latestActivity)">
            {{ mapStatus(item.latestActivity) }}
          </span>
        </div>
        <div class="ret-id-and-status">
          <div class="img-invoice">
            <mat-icon class="calendar_today">calendar_today</mat-icon>
            <span> {{ formatDate(item.salesReturnInfo?.createdAt) | date:'dd MMM yyyy' || 'N/A' }}</span>
            
          </div>
        <span class="amount" [ngClass]="getStatusClass(item.latestActivity)" > 
        
          ₹{{ item.salesReturnInfo?.totalAmount || '0.00' }} </span>
        </div>
      </div>

      <div class="item-name">
        <ng-container *ngFor="let it of item.items; let last = last">
          {{ it.notes }}<span *ngIf="!last">, </span>
        </ng-container>
      </div>


      <div class="item-desc">
        {{ (item.items && item.items.length && item.salesReturnInfo?.notes) || 'No description' }}
      </div>

      <div class="item-meta">
        <div class="svg-name-and-data">
          <span class="span1"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.99992 8H9.99992M5.99992 10.6667H9.99992M11.3333 14H4.66659C4.31296 14 3.97382 13.8595 3.72378 13.6095C3.47373 13.3594 3.33325 13.0203 3.33325 12.6667V3.33333C3.33325 2.97971 3.47373 2.64057 3.72378 2.39052C3.97382 2.14048 4.31296 2 4.66659 2H8.39059C8.56738 2.00004 8.73692 2.0703 8.86192 2.19533L12.4713 5.80467C12.5963 5.92966 12.6665 6.0992 12.6666 6.276V12.6667C12.6666 13.0203 12.5261 13.3594 12.2761 13.6095C12.026 13.8595 11.6869 14 11.3333 14Z" stroke="black" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Invoice:</span>
            <span>{{ getInvoiceNumber(item) }}</span>
        </div>
        <div class="svg-name-and-data">
          <span class="span1"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.66667 4.66667H4.67333M4.66667 2H8C8.34133 2 8.68267 2.13 8.94267 2.39067L13.6093 7.05733C13.8593 7.30737 13.9997 7.64645 13.9997 8C13.9997 8.35355 13.8593 8.69263 13.6093 8.94267L8.94267 13.6093C8.69263 13.8593 8.35355 13.9997 8 13.9997C7.64645 13.9997 7.30737 13.8593 7.05733 13.6093L2.39067 8.94267C2.26667 8.81901 2.16833 8.67208 2.10128 8.51031C2.03424 8.34854 1.99982 8.17511 2 8V4.66667C2 3.95942 2.28095 3.28115 2.78105 2.78105C3.28115 2.28095 3.95942 2 4.66667 2Z" stroke="black" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Part No:</span>
            <span>{{ item.items[0]?.partNumber || 'N/A' }}</span>
        </div>
        <div class="svg-name-and-data">
          <span class="span1"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6667 7.33333V4.66667C10.6667 3.95942 10.3858 3.28115 9.8857 2.78105C9.3856 2.28095 8.70733 2 8.00008 2C7.29284 2 6.61456 2.28095 6.11446 2.78105C5.61437 3.28115 5.33341 3.95942 5.33341 4.66667V7.33333M3.33341 6H12.6667L13.3334 14H2.66675L3.33341 6Z" stroke="#505050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Order ID:</span>
            <span>{{ item.salesReturnInfo?.orderId || 'N/A' }}</span>
        </div>
        <div class="svg-name-and-data-with-view">
          <div class="svg-name-and-data-without-view">
            <span class="span1"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.33333 4.66667V2M10.6667 4.66667V2M4.66667 7.33333H11.3333M3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V4.66667C14 4.31304 13.8595 3.97391 13.6095 3.72386C13.3594 3.47381 13.0203 3.33333 12.6667 3.33333H3.33333C2.97971 3.33333 2.64057 3.47381 2.39052 3.72386C2.14048 3.97391 2 4.31304 2 4.66667V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14Z" stroke="black" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Purchased on:</span>
              <span>{{ parseDateString(item.salesReturnInfo?.purchasedDate) | date:'dd MMM yyyy' }}</span>
          </div>
            <div class="view-button" (click)="openPopup(item)">
              <div class="view-btn-return">
                <mat-icon class="view-btn-icon" aria-hidden="true">keyboard_arrow_right</mat-icon>
                <div class="view">View Details</div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EMPTY STATE UI ALL-->
  <div
    *ngIf="!loading && filteredList.length === 0 && selectedTab === 'All'"
    class="returns-empty-ui"
  >
    <span class="bubble bubble-1"></span>
    <span class="bubble bubble-2"></span>
    <span class="bubble bubble-3"></span>
    <div class="empty-card">
      <!-- <img src="assets/images/empty-returns-clipboard.png" class="empty-icon" /> -->
      <div class="empty-card-img">📋</div>

      <h2>Your returns dashboard is ready!</h2>
      <p class="subtext">
        No returns yet, but don't worry — we’re here to help whenever you need us.
        Starting a return is quick and easy.
      </p>

      <button class="btn-primary" (click)="openReturnVideo()">
        <div>Show me how to return an item</div>
        <mat-icon>arrow_right_alt</mat-icon>
      </button>
    </div>

    <div class="tips-section">
      <h3>💡 Helpful Tips & Tricks</h3>

      <div class="tip-card blue">
        <span class="emoji">⏰</span>
        <div>
          <h4>7-Day Return Window</h4>
          <p>You have plenty of time! Returns can be started within 7 days of your purchase.</p>
        </div>
      </div>

      <div class="tip-card yellow">
        <span class="emoji">📦</span>
        <div>
          <h4>Keep That Box!</h4>
          <p>Original packaging helps us process your return much faster and smoother.</p>
        </div>
      </div>

      <div class="tip-card green">
        <span class="emoji">💸</span>
        <div>
          <h4>Quick Refunds</h4>
          <p>Most refunds are processed within 3-5 business days. We work fast!</p>
        </div>
      </div>

      <div class="support-footer">
        <span class="emoji">🤝</span>
        <div>
          <div class="strong-and-p"><strong>Need help?</strong>  <p>Our friendly support team is here for you always!</p></div>
        </div>
      </div>
    </div>
  </div>

    <!-- EMPTY STATE UI CREATE-->
  <div
    *ngIf="!loading && filteredList.length === 0 && selectedTab === 'Created'"
    class="returns-empty-ui"
  >
    <span class="bubble bubble-1"></span>
    <span class="bubble bubble-2"></span>
    <span class="bubble bubble-3"></span>
    <div class="empty-card">
      <!-- <img src="assets/images/empty-returns-clipboard.png" class="empty-icon" /> -->
      <div class="empty-card-img">✍️</div>

      <h2>Ready to create your first return?</h2>
      <p class="subtext">
        Haven't started any returns yet? No problem! You can easily create one from any of your recent orders.
      </p>

      <button class="btn-primary"  (click)="openReturnVideo()">
        <div>Show me how to return an item</div>
        <mat-icon>arrow_right_alt</mat-icon>
      </button>
    </div>

    <div class="tips-section">
      <h3>💡 Helpful Tips & Tricks</h3>

      <div class="tip-card blue">
        <span class="emoji">⏰</span>
        <div>
          <h4>7-Day Return Window</h4>
          <p>You have plenty of time! Returns can be started within 7 days of your purchase.</p>
        </div>
      </div>

      <div class="tip-card yellow">
        <span class="emoji">📦</span>
        <div>
          <h4>Keep That Box!</h4>
          <p>Original packaging helps us process your return much faster and smoother.</p>
        </div>
      </div>

      <div class="tip-card green">
        <span class="emoji">💸</span>
        <div>
           <h4>Quick Refunds</h4>
           <p>Most refunds are processed within 3-5 business days. We work fast!</p>
        </div>
      </div>

      <div class="support-footer">
        <span class="emoji">🤝</span>
        <div>
          <div class="strong-and-p"><strong>Need help?</strong>  <p>Our friendly support team is here for you always!</p></div>
        </div>
      </div>
    </div>
  </div>

      <!-- EMPTY STATE UI rECEIVED-->
      <div
        *ngIf="!loading && filteredList.length === 0 && selectedTab === 'Received'"
        class="returns-empty-ui"
      >
        <span class="bubble bubble-1"></span>
        <span class="bubble bubble-2"></span>
        <span class="bubble bubble-3"></span>
        <div class="empty-card">
          <!-- <img src="assets/images/empty-returns-clipboard.png" class="empty-icon" /> -->
          <div class="empty-card-img">📦</div>

          <h2>We're waiting for your packages</h2>
          <p class="subtext">
            Returns received by us will appear here once they arrive at our warehouse.
          </p>

          <button class="btn-primary"  (click)="openReturnVideo()">
            <div>Show me how to return an item</div>
            <mat-icon>arrow_right_alt</mat-icon>
          </button>
        </div>

        <div class="tips-section">
          <h3>💡 Helpful Tips & Tricks</h3>

          <div class="tip-card blue">
            <span class="emoji">⏰</span>
            <div>
              <h4>7-Day Return Window</h4>
              <p>You have plenty of time! Returns can be started within 7 days of your purchase.</p>
            </div>
          </div>

          <div class="tip-card yellow">
            <span class="emoji">📦</span>
            <div>
              <h4>Keep That Box!</h4>
              <p>Original packaging helps us process your return much faster and smoother.</p>
            </div>
          </div>

          <div class="tip-card green">
            <span class="emoji">💸</span>
            <div>
               <h4>Quick Refunds</h4>
              <p>Most refunds are processed within 3-5 business days. We work fast!</p>
            </div>
          </div>

          <div class="support-footer">
            <span class="emoji">🤝</span>
            <div>
              <div class="strong-and-p"><strong>Need help?</strong>  <p>Our friendly support team is here for you always!</p></div>
            </div>
          </div>
        </div>
      </div>

        <!-- EMPTY STATE UI REFUNDED-->
      <div
        *ngIf="!loading && filteredList.length === 0 && selectedTab === 'Refunded'"
        class="returns-empty-ui"
      >
        <span class="bubble bubble-1"></span>
        <span class="bubble bubble-2"></span>
        <span class="bubble bubble-3"></span>
        <div class="empty-card">
          <!-- <img src="assets/images/empty-returns-clipboard.png" class="empty-icon" /> -->
          <div class="empty-card-img">💰</div>

          <h2>No refunds processed yet</h2>
          <p class="subtext">
            When we process your returns and issue refunds, you'll see all the details right here. We typically process refunds super quickly!
          </p>

          <button class="btn-primary"  (click)="openReturnVideo()">
            <div>Show me how to return an item</div>
            <mat-icon>arrow_right_alt</mat-icon>
          </button>
        </div>

        <div class="tips-section">
          <h3>💡 Helpful Tips & Tricks</h3>

          <div class="tip-card blue">
            <span class="emoji">⏰</span>
            <div>
              <h4>7-Day Return Window</h4>
              <p>You have plenty of time! Returns can be started within 7 days of your purchase.</p>
            </div>
          </div>

          <div class="tip-card yellow">
            <span class="emoji">📦</span>
            <div>
              <h4>Keep That Box!</h4>
              <p>Original packaging helps us process your return much faster and smoother.</p>
            </div>
          </div>

          <div class="tip-card green">
            <span class="emoji">💸</span>
            <div>
               <h4>Quick Refunds</h4>
               <p>Most refunds are processed within 3-5 business days. We work fast!</p>
            </div>
          </div>

          <div class="support-footer">
            <span class="emoji">🤝</span>
            <div>
              <div class="strong-and-p"><strong>Need help?</strong>  <p>Our friendly support team is here for you always!</p></div>
            </div>
          </div>
        </div>
      </div>

      <!-- EMPTY STATE UI DECLINED-->
      <div
        *ngIf="!loading && filteredList.length === 0 && selectedTab === 'Declined'"
        class="returns-empty-ui"
      >
        <span class="bubble bubble-1"></span>
        <span class="bubble bubble-2"></span>
        <span class="bubble bubble-3"></span>
        <div class="empty-card">
          <!-- <img src="assets/images/empty-returns-clipboard.png" class="empty-icon" /> -->
          <div class="empty-card-img">🛡️</div>

          <h2>Do Declined Returns!</h2>
          <p class="subtext">
            Fantastic news — none of your returns have been declined. Keep up the great work with your return requests!
          </p>

          <button class="btn-primary"  (click)="openReturnVideo()">
            <div>Show me how to return an item</div>
            <mat-icon>arrow_right_alt</mat-icon>
          </button>
        </div>

        <div class="tips-section">
          <h3>💡 Helpful Tips & Tricks</h3>

          <div class="tip-card blue">
            <span class="emoji">⏰</span>
            <div>
              <h4>7-Day Return Window</h4>
              <p>You have plenty of time! Returns can be started within 7 days of your purchase.</p>
            </div>
          </div>

          <div class="tip-card yellow">
            <span class="emoji">📦</span>
            <div>
              <h4>Keep That Box!</h4>
              <p>Original packaging helps us process your return much faster and smoother.</p>
            </div>
          </div>

          <div class="tip-card green">
            <span class="emoji">💸</span>
            <div>
               <h4>Quick Refunds</h4>
              <p>Most refunds are processed within 3-5 business days. We work fast!</p>
            </div>
          </div>

          <div class="support-footer">
            <span class="emoji">🤝</span>
            <div>
              <div class="strong-and-p"><strong>Need help?</strong>  <p>Our friendly support team is here for you always!</p></div>
            </div>
          </div>
        </div>
      </div>

</div>

<!-- Popup Modal -->
<div class="overlay-return" [class.visible]="showPopup" (click)="closePopup()">
  <div class="popup-card" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h3>{{ selectedItem?.returnId }}</h3>
      <button class="close-btn" (click)="closePopup()">×</button>
    </div>

    <div class="return-timeline">
      <p class="section-title">Return Timeline</p>

      <ul class="timeline-list">

        <!-- Return Created -->
        <li class="timeline-step"
            [ngClass]="{ 
              'completed': selectedItem?.status === 'Created' || selectedItem?.status === 'Received' || selectedItem?.status === 'Refunded' || selectedItem?.status === 'Declined' 
            }">
          <div>
            <span>Return Created</span>
            <div class="timeline-date">
              {{ selectedItem?.salesReturnInfo?.createdAt ? (parseDateString(selectedItem.salesReturnInfo.createdAt) | date:'dd MMM yyyy') : 'Pending' }}
            </div>
          </div>
        </li>

        <!-- Show Item Received & Refund only if NOT Declined -->
        <ng-container *ngIf="selectedItem?.status !== 'Declined'">
          
          <!-- Item Received -->
          <li class="timeline-step"
              [ngClass]="{ 'completed': selectedItem?.status === 'Received' || selectedItem?.status === 'Refunded' }">
            <div>
              <span>Item Received</span>
              <div class="timeline-date">
                {{
                  (getLatestDate(selectedItem?.statusHistory, 'receiveStatus') && getLatestDate(selectedItem?.statusHistory, 'receiveStatusDate'))
                    ? (parseDateString(getLatestDate(selectedItem?.statusHistory, 'receiveStatusDate')) | date:'dd MMM yyyy')
                    : 'Pending'
                }}
              </div>

            </div>
          </li>

          <!-- Refund Processed -->
          <li class="timeline-step"
              [ngClass]="{ 'completed': selectedItem?.status === 'Refunded' }">
            <div>
              <span>Refund Processed</span>
              <div class="timeline-date">
                {{
                  (getLatestDate(selectedItem?.statusHistory, 'refundStatusDate'))
                    ? (parseDateString(getLatestDate(selectedItem?.statusHistory, 'refundStatusDate')) | date:'dd MMM yyyy')
                    : 'Pending'
                }}
              </div>
            </div>
          </li>
        </ng-container>

        <!-- Return Declined -->
        <li class="timeline-step"
            *ngIf="selectedItem?.status === 'Declined'"
            [ngClass]="{ 'declined': selectedItem?.status === 'Declined' }">
          <div>
            <span>Return Declined</span>
            <div class="timeline-date">
              {{ getLatestDate(selectedItem?.statusHistory, 'salesReturnRecvDate') ? (parseDateString(getLatestDate(selectedItem?.statusHistory, 'salesReturnRecvDate')) | date:'dd MMM yyyy') : 'Pending' }}
            </div>
          </div>
        </li>

      </ul>
    </div>

    <hr />

   <div class="return-details">
      <p class="section-title">Return Details</p>
      <div class="item-name">
        <ng-container *ngFor="let item of selectedItem?.items; let last = last">
          {{ item.notes }}<span *ngIf="!last">, </span>
        </ng-container>
      </div>
      <p class="item-description">
        Reason: {{ selectedItem?.salesReturnInfo?.notes || 'No description' }}
      </p>
      <p class="order-go">
        Invoice: {{ getSelectedInvoiceNumber() }} |
        Part No:   {{ selectedItem?.items && selectedItem.items.length ? selectedItem.items[0].partNumber : 'N/A' }}

      </p>
      <p class="order-go">
         Order ID: {{ selectedItem?.salesReturnInfo?.orderId || 'N/A' }} |
        Order Date: {{ parseDateString(selectedItem?.salesReturnInfo?.purchasedDate) | date:'dd MMM yyyy' }}
      </p>
      
      <div *ngIf="selectedItem?.status === 'Declined'" class="declined-box">
        <strong>Return Declined</strong><br />
        <span>Return period expired (30 days)</span>
      </div>
    </div>
    <hr />
  <div class="download-credit-note"> 
    <button 
        *ngIf="
          selectedItem?.salesReturnInfo?.creditNoteId && 
          selectedItem?.salesReturnInfo?.creditNoteNumber && 
          hasRefundedStatus(selectedItem)
        "
        class="btn-download" 
        (click)="downloadCreditNote(selectedItem.salesReturnInfo)">
        Download Credit Note
    </button>
  <button class="btn-close" (click)="closePopup()">Close</button>
  </div>
  </div>
</div>
